module.exports = __webpack_public_path__ + "media/images/sp/page_common/keywords/keyword_photogenicjourney-fa86db2dccf17ccd1ed29c1f122e24db.jpg";